import { render, staticRenderFns } from "./ModrList.vue?vue&type=template&id=58248043&scoped=true&"
import script from "./ModrList.vue?vue&type=script&lang=js&"
export * from "./ModrList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58248043",
  null
  
)

export default component.exports